import { useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

import { DueDate } from "./date-picker"
import { MemberPicker } from "./member-picker"
import { PriorityPicker } from "./priority-picker"
import { StatusPicker } from "./status-picker"
import { setDynamicModalObj, toggleModal, updateTaskAction } from "../../store/board.actions"

import { updateSubTask as actualizarSubActividad } from "../../store/grupo.actions";
import { handleResponsable } from "../../store/user.actions";


import { UpdatedPicker } from "./updated-picker"
import { NumberPicker } from "./number-picker"

import { FilePicker } from "./file-picker"

import { TbArrowsDiagonal } from 'react-icons/tb'
import { BiDotsHorizontalRounded, BiMessageRoundedAdd } from 'react-icons/bi'
import { HiOutlineChatBubbleOvalLeft } from 'react-icons/hi2'
import { userService } from '../../services/user.service';
import { ROLES } from '../../services/user.service'; // Asegúrate de importar correctamente
import { CiTurnL1 } from "react-icons/ci";
import { IoReturnDownForwardOutline } from "react-icons/io5";
import { TbRadiusBottomLeft } from "react-icons/tb";
import { IoReturnDownForward } from "react-icons/io5";


export function SubTaskPreview({customHeight, getHoras, task,responsables, group, board, handleCheckboxChange, isMainCheckbox }) {
    const [taskToEdit, setTaskToEdit] = useState(task);

    const [RespToEdit, setRestEdit] = useState(responsables);
    const [isTyping, setIsTyping] = useState(false);
    const [isClick, setIsClick] = useState(false)
    const isOpen = useSelector((storeState) => storeState.boardModule.isBoardModalOpen)
    // const user = useSelector(storeState => storeState.userModule.user)
    const [user, setUser] = useState(userService.getLoggedinUser().data.data);
    const dynamicModalObj = useSelector(storeState => storeState.boardModule.dynamicModalObj)
    const elTaskPreview = useRef(null)
    const elMenuTask = useRef()
    const navigate = useNavigate()
    const isEditable = user.rol === ROLES.ADMIN || user.rol === ROLES.TECNICO;

    const guest = "https://res.cloudinary.com/du63kkxhl/image/upload/v1675013009/guest_f8d60j.png"

    useEffect(() => {
        setIsClick(isMainCheckbox.isActive)
    }, [isMainCheckbox])

    // async function updateTask(cmpType, data, activity) {
    //     const taskToUpdate = structuredClone(task)
    //     taskToUpdate[cmpType] = data
    //     taskToUpdate.updatedBy.date = Date.now()
    //     taskToUpdate.updatedBy.imgUrl = (user && user.imgUrl) || guest
    //     try {
    //         await updateTaskAction(board, group.id, taskToUpdate, activity)
    //     } catch (err) {
    //         console.log(err)
    //     }
    // }

    async function onUpdateTaskTitle(ev) {
        const value = ev.target.innerText
        task.title = value
        try {
            toggleOnTyping()
            await updateTaskAction(board, group.id, task)
        } catch (err) {
            console.log('Failed to save')
        }
    }

    function onOpenModal() {
        toggleModal(isOpen)
        navigate(`/board/${board._id}/${group.id}/${task.id_subactividad}`)
    }

    function onCheckBoxChange() {
    // Crear una copia del objeto task
    const updatedTask = { ...task, group_id: group.id_grupo }; // Supongo que tienes el valor de group.id disponible
        
         handleCheckboxChange(updatedTask)
       
       
        setIsClick(!isClick)
    }

    // function onCheckBoxChange() {
    //     handleCheckboxChange(task)
    //     console.log("sub tarea selecciionada",task);
    //     setIsClick(!isClick)
    // }

    function onToggleTaskModal() {
        const isOpen = dynamicModalObj?.task?.id_subactividad === task.id_subactividad && dynamicModalObj?.type === 'menu-task' ? !dynamicModalObj.isOpen : true
        const { x, y, height } = elMenuTask.current.getClientRects()[0]
        setDynamicModalObj({ isOpen, pos: { x: (x - 10), y: (y + height) }, type: 'menu-task', group: group, task: task })
    }

    function toggleOnTyping() {
        setIsTyping(true);
        elMenuTask.current.classList.toggle('on-typing')
        elTaskPreview.current.classList.toggle('on-typing')
    }



    // Función para manejar la actualización de la tarea
async function onUpdateSubTask(ev, field, number) {
    ev.preventDefault();

    // Actualiza el campo específico en taskToEdit
    const updatedTask = {
        ...taskToEdit,
        [field]: number
    };

    // Actualiza el estado con los nuevos detalles de la tarea
   
    // Prepara updatedTask para actualizar en el backend
    const taskForUpdate = {
        ...updatedTask,
        // fk_estado_id: 1,
        // fk_proyecto_id: 1,
        fk_grupo_id: group.id_grupo,
        updated_at: new Date().toISOString()
    };

    try {
        await actualizarSubActividad(taskForUpdate); // Función para actualizar la tarea en el backend
        setTaskToEdit(updatedTask);

        getHoras();
    } catch (err) {
    }
}


    function handleInputChange(ev, field) {
        setIsTyping(false);
        onUpdateSubTask(ev,field, ev.target.innerText);
    }

    
    function handleUpdateMembers(idActividad, idField, idResponsable, mode) {
        const newResponsable = {
            ...RespToEdit,
            [idField]: idActividad,
            fk_usuario_id: idResponsable,
        };

        setRestEdit(newResponsable);

        handleResponsable(newResponsable, mode);
    };

    

    return (
        <section>
            <div className={'task-preview flex'} ref={elTaskPreview} >
                <div ref={elMenuTask} className="sticky-div" style={{ borderColor: group.color  }}>
                <div style={{ height: customHeight, borderLeft: `1px solid ${group.color}` }} className="task-menu">
                    {/* Nuevo div vacío con bordes */}
                    <div
                        style={{
                        borderLeft: `1px solid ${group.color}`, // Borde derecho con el color del grupo
                        borderBottom: `1px solid ${group.color}`, // Borde inferior con el color del grupo
                        width: '45px', // Ajusta el ancho del div según sea necesario
                        height: '10px', // Ajusta la altura del div según sea necesario
                        borderBottomLeftRadius: '9px',
                        marginBottom: '5px',
                        marginLeft: '-0.6px',

                    
                        }}
                    />
                    </div>

                    {/* <div className="check-box">
                        <input type="checkbox" checked={isClick} onChange={onCheckBoxChange} />
                    </div> */}

                    <div className="check-box" style={{ pointerEvents: isEditable ? 'auto' : 'none', opacity: isEditable ? 1 : 0.5 }}>
                        <input type="checkbox" checked={isClick} onChange={onCheckBoxChange} disabled={!isEditable} />
                    </div>

                    <div ref={elMenuTask} style={{ borderColor: group.color ,zIndex:5000, height:customHeight}} className="tooltip-container" >
                        <div className="task-title picker flex align-center space-between" style={{width:"465px", overflowY: "auto", height:customHeight}}>
                            <blockquote contentEditable={isEditable} onFocus={toggleOnTyping} 
                            
                                
                                onBlur={(ev) => handleInputChange(ev, 'descripcion')}
                                suppressContentEditableWarning={true} 
                                style={{marginLeft:"10px" , width:"600px", whiteSpace:"pre-wrap", cursor: isEditable ? 'pointer' : 'not-allowed'}}>
                                {taskToEdit.descripcion}
                            </blockquote>

                            {!isTyping && <div className="tooltip-text" style={{zIndex:5000}}>
                                {taskToEdit.descripcion}
                            </div> 
                            } 
                            {/* <div className="open-task-details " onClick={onOpenModal}>
                                <TbArrowsDiagonal />
                                <span className="open-btn">Open</span>
                            </div> */}

                            {/* <div onClick={onOpenModal} className="chat-icon">
                                {task.comments.length > 0 && <div>
                                    <HiOutlineChatBubbleOvalLeft className="comment-chat" />
                                    <div className="count-comment">{task.comments.length}</div>
                                </div>}
                                {task.comments.length === 0 && <BiMessageRoundedAdd className="icon" />}
                            </div> */}
                        </div>
                    </div>

                </div>

                {/* {board.cmpsOrder.map((cmp, idx) => {
                    return (
                        <DynamicCmp
                        cmp={cmp}
                        key={cmp + idx}
                        info={task}
                        onUpdate={updateTask}
                        />)
                    })} */}

                <div ref={elMenuTask} style={{ borderColor: group.color, width:"230px !important", height:customHeight}}>
                    <MemberPicker customHeight={customHeight} info={{ id_actividad: task.id_subactividad, idField: "fk_subactividad_id", campo:"subtask-preview" }} responsables={responsables} onUpdate={handleUpdateMembers} userRol={user.rol} />
                </div>

                <NumberPicker customHeight={customHeight} info={{ number: taskToEdit.horas_trabajo }}  field="horas_trabajo" onUpdate={onUpdateSubTask} userRol={user.rol} />
                <StatusPicker  customHeight={customHeight}  info={{campo:"subtask-preview", estado: taskToEdit.fk_estado_id }} field="fk_estado_id" onUpdate={onUpdateSubTask} userRol={user.rol}/>
                <DueDate customHeight={customHeight} info={{ date: taskToEdit.fecha_inicio, campo:"subtask-preview"}} field="fecha_inicio" onUpdate={onUpdateSubTask} userRol={user.rol} />
              

                
                
                    
                <div className="empty-div"></div>


                
            </div>

        </section>
    )
}

function DynamicCmp({ cmp, info, onUpdate }) {
    switch (cmp) {
        case "status-picker":
            return <StatusPicker info={info} onUpdate={onUpdate} />
        case "member-picker":
            return <MemberPicker info={info} onUpdate={onUpdate} />
        case "date-picker":
            return <DueDate info={info} onUpdate={onUpdate} />
        case "priority-picker":
            return <PriorityPicker info={info} onUpdate={onUpdate} />
        case "number-picker":
            return <NumberPicker info={info} onUpdate={onUpdate} />
        case "file-picker": 
            return <FilePicker info={info} onUpdate={onUpdate} />
        case "updated-picker":
            return <UpdatedPicker info={info} onUpdate={onUpdate} />
        default:
            return <p>UNKNOWN {cmp}</p>
    }
}